export const LOGGED_OUT_STATE = {
    state: "logged_out"
};
